import { Sponsor } from '../types';
export const INITIAL_SPONSORS: Sponsor[] = [];
